import React, { useEffect } from "react";
import "./Prescription.css"; // Import a separate CSS file for styling
import { Table } from "react-bootstrap";
import { useContext } from "react";
import WaitingContext from "../../../store/waitingListContext";
import AuthContext from "../../../store/auth-context";
import { useTranslation } from "react-i18next";

const Prescriptions = ({ medicineData, checkedData }) => {
  const { t } = useTranslation();
  const authCtx = useContext(AuthContext);
  const prescriptionData = useContext(WaitingContext);
  const medicine = prescriptionData.waitingPatient;

  return (
    <div className="prescription-container">
      <style>
        {`
          @media print {
            body {
              font-size: 12pt;
              -webkit-print-color-adjust: exact;
            }
            .prescription-container {
              width: 100%;
            }
            .patient-info-container {
              display: flex;
              justify-content: space-between;
              width: 100%;
              margin-bottom: 0px;
            }
            .info-block {
              width: 48%;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid #000;
              padding: 7px;
              text-align: left;
            }
               .setMarg {
                text-align: center;
                 font-size:22px;
              }
                  .info-block p strong {
              font-weight:600;
              }
              .text-transform{
              text-transform: capitalize;
              }
              .set2Marg {
                text-align: center;
                font-size:15px;
              }
              .hospitalAdd{
                text-align: center;
                margin-bottom:0.2rem;
                padding-top:0.2rem;
                margin-top:0.2rem;
              }
                .secblock {
                  text-align: right;
              }
            th {
              background-color: #f2f2f2 !important;
            }
            .no-print {
              display: none;
            }
               margin-top: 5px;
              margin-bottom: 5px;
          }
              .set2Marg {
              margin-top: 3px;
              margin-bottom: 3px;
            }
        `}
      </style>

      <h1 className="text-center text-uppercase setMarg">
        {authCtx.hospitalName}
      </h1>

      <div className="text-center mb-0 pb-0">
        <h5 className="text-center set2Marg">
          {medicine?.doctorId?.firstName +
            " " +
            medicine?.doctorId?.middleName +
            " " +
            medicine?.doctorId?.lastName}{" "}
          ({medicine?.doctorId?.degree})
        </h5>
        <p className="hospitalAdd pt-0 mb-0">{authCtx.hospitalAddress}</p>
      </div>

      <div className="container-fluid">
        <div className="patient-info-container">
          <div className="info-block">
            <p>
              <strong>{t("Patient Id")}:</strong> {medicine?.patientId?.patientId || "-"}
            </p>
            <p>
              <strong>{t("Reg. No")}:</strong> {authCtx.regnumber || "-"}
            </p>
            <p className="text-capitalize">
              <strong>{t("Name")}:</strong> {medicine?.patientId?.firstName}{" "}
              {medicine?.patientId?.lastName || "-"}
            </p>


          </div>

          <div className="info-block">
            <div className="secblock">
              <p>
                <strong>{t("Date")}:</strong> {new Date().toLocaleDateString()}
              </p>
              <p>
                <strong>{t("Mobile")}:</strong> {medicine?.patientId?.mobile || "-"}
              </p>
              <p className="text-capitalize">
                <strong>{t("Address")}:</strong> {medicine?.patientId?.address || "-"}
              </p>

            </div>
          </div>
        </div>

        <div className="container-fluid">
          <p>
            <strong>{t("Diagnosis")}:</strong> {checkedData && checkedData?.diagnosis ? checkedData?.diagnosis : " - "},

            <strong>{t("Weight")}:</strong> {checkedData && checkedData?.weight ? checkedData?.weight : ""},
            <strong className="pr-3">{t("BP")}:</strong> {checkedData && checkedData?.bps ? checkedData?.bps : ""}/{checkedData && checkedData?.bpd ? checkedData?.bpd : ""} mm Hg,
            <strong className="pr-3">{t("Temp")}:</strong> {checkedData && checkedData?.temp ? checkedData?.temp : ""},
          </p>
        </div>
        <div className="container-fluid">
          <p>
            <strong>{t("Complaint")}:</strong> {checkedData && checkedData?.complaint ? checkedData?.complaint : " - "},
          </p>
        </div>
      </div>

      <Table striped bordered hover responsive className="prescription-table">
        <thead>
          <tr>
            <th>{t("Medicine")}</th>
            <th>{t("Type")}</th>
            <th>{t("Dosage")}</th>
            <th>{t("Breakfast")}</th>
            <th>{t("Lunch")}</th>
            <th>{t("Dinner")}</th>
            <th>{t("Days")}</th>
          </tr>
        </thead>
        <tbody>
          {medicineData && medicineData.length > 0 && medicineData.map((prescription, index) => (
            <tr key={index}>
              <td>
                {prescription?.medicineName || ""}
              </td>
              <td>{prescription?.type || ""}</td>
              <td>{prescription?.dosage || ""}</td>
              <td>{prescription?.breakFastDose || "...."}</td>
              <td>{prescription?.lunchDose || "...."}</td>
              <td>{prescription?.dinnerDose || "...."}</td>
              <td>{prescription?.days || ""}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Prescriptions;